import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { PropertyFeeValidation } from 'uplisting-frontend/validations';

export default class PropertyFeeRepositoryService extends BaseRepositoryService<
  ModelRegistry['property-fee']
> {
  recordName = 'property-fee';
  implementMethods = ['buildChangeset'];

  validation = PropertyFeeValidation;
}

declare module '@ember/service' {
  interface Registry {
    'repositories/property-fee': PropertyFeeRepositoryService;
  }
}
